<script>
  import { onMount, onDestroy } from "svelte";
  import { Radar } from "svelte-chartjs";
  import { _ } from "svelte-i18n";
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LinearScale,
    RadialLinearScale,
    LineElement,
  } from "chart.js";

  export let chartDataInput;

  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    PointElement,
    LinearScale,
    RadialLinearScale,
    LineElement,
  );

  onMount(() => {
    loadData();
    window.addEventListener("resize", updateChart);
  });

  onDestroy(() => {
    window.removeEventListener("resize", updateChart);
  });

  let chartResult;
  let chartData;
  let chartStatus = "NEW";

  let chartComponent

  
  function loadData() {
    chartStatus = "LOADING";

    chartDataInput["TOEIC_READ"];

    chartData = {
      labels: ["Listening", "Reading", "Speaking"],
      datasets: [
        {
          label: "Student Scores",
          data: [
            chartDataInput["TOEIC_LISTEN"],
            chartDataInput["TOEIC_READ"],
            chartDataInput["TOEIC_SPEAK"],
          ],
          fill: true, // fills the area under the line (optional)
          showLine: true, // explicitly tells Chart.js to draw the connecting line
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderColor: "rgba(54, 162, 235, 1)",
          pointBackgroundColor: "rgba(54, 162, 235, 1)",
          borderWidth: 2,
        },
        {
          label: "Passing Score",
          data: [
            275/5,
            275/5,
            120/2,
          ],
          fill: true, // fills the area under the line (optional)
          showLine: true, // explicitly tells Chart.js to draw the connecting line
          backgroundColor: "rgba(154, 62, 235, 0.2)",
          borderColor: "rgba(154, 62, 235, 1)",
          pointBackgroundColor: "rgba(154, 62, 235, 1)",
          borderWidth: 1,
        },
      ],
    };

    // new Chart(myChart.getContext('2d'),chartData)

    console.log("chartResult", chartResult, chartData);
    chartStatus = "OK";
  }

  function updateChart() {
    if (chartComponent && chartComponent.chart) {
      chartComponent.chart.resize();
      chartComponent.chart.update();
    }
  }
</script>

{#if chartStatus === "OK"}
  <Radar bind:this={chartComponent}
    data={chartData}
    options={{
      responsive: true,
      elements: {
        line: {
          tension: 0,
        },
      },
      scales: {
        r: {
          angleLines: {
            display: true,
          },
          suggestedMin: 0,
          suggestedMax: 100,
          pointLabels: {
          font: {
            size: 20  // set to your desired font size
          }
        }
        },
      },
      plugins: {
        legend: {
          display: true,
        },
      },
    }}
  />
{/if}
